import {FC, useEffect} from 'react'
import {useDispatch, useSelector} from 'react-redux'
import {getOrders, resetOrderState, selectFilter} from '../redux/order/ordersSlice'
import AllOrdersTableList from './AllOrdersTableList'
import useControlledFetch from 'app/components/useControlledFetch'
import {RootState} from 'setup'

const OrderList: FC = () => {
  const dispatch = useDispatch()
  const filter = useSelector<RootState, any>(selectFilter)

  const {controller} = useControlledFetch()

  useEffect(() => {
    if (filter.canLoad) {
      dispatch(getOrders({filter, signal: controller()}))
    }
  }, [controller, dispatch, filter])

  useEffect(() => {
    return () => {
      dispatch(resetOrderState())
    }
  }, [dispatch])

  return <AllOrdersTableList />
}

export default OrderList
